export type OrderItem = {
  id: number;
  title: string;
  url: string;
  status: string;
  order_id: number;
  arrangement: {
    code: string;
    title: string;
  };
  instruments: {
    code: string;
    title: string;
  }[];
  img: {
    src: string;
    src_256_362: string;
  };
  complexity: {
    level: 10 | 20 | 30;
    title: string;
  } | null;
  musicians: {
    title: string;
  }[];
  variants:
    | {
        BASE?: string;
        MIDI?: string;
      }
    | [];
};

export type Order = {
  id: number;
  date: string;
  items: Record<string, OrderItem>;
  pay_url: string;
  status_name: string;
  /**
   * N - Заказ принят и ожидает оплаты
   * P - Полностью готов
   * F - Полный
   * PO - Предварительный заказ
   * '' - Неизвостно
   */
  status_id: 'N' | '' | 'P' | 'F' | 'PO';
  price: string;
  payed: boolean;
};
